module.exports = __webpack_public_path__ + "static/img/cg_zs.42a7a4ff.jpg";